<template>
  <div class="page__wrapper">
    <form class="repgroup__form" v-on:submit.prevent="submitFactory">
      <div class="form__name">Add a Factory</div>
      <label>Business Name</label>
      <input v-model="business_name" required type="text" placeholder="Business Name"/>
      <label>Telephone</label>
      <input v-model="phone" required type="text" placeholder="Telephone"/>
      <label>Website</label>
      <input v-model="website" type="text" placeholder="Website"/>
      <label>Alaska Rep</label>
      <input v-model="ak" list="reps" placeholder="Alaska Rep"/>
      <label>Canada Rep</label>
      <input v-model="can" list="reps" placeholder="Canada Rep"/>
      <label>Colorado Rep</label>
      <input v-model="co" list="reps" placeholder="Colorado Rep"/>
      <label>Hawaii Rep</label>
      <input v-model="hi" list="reps" placeholder="Hawaii Rep"/>
      <label>Idaho Rep</label>
      <input v-model="id" list="reps" placeholder="Idaho Rep"/>
      <label>Montana Rep</label>
      <input v-model="mt" list="reps" placeholder="Montana Rep"/>
      <label>Oregon Rep</label>
      <input v-model="or" list="reps" placeholder="Oregon Rep"/>
      <label>Texas Rep</label>
      <input v-model="tx" list="reps" placeholder="Texas Rep"/>
      <label>Washington Rep</label>
      <input v-model="wa" list="reps" placeholder="Washington Rep"/>
      <label>Wyoming Rep</label>
      <input v-model="wy" list="reps" placeholder="Wyoming Rep"/>
      <datalist id="reps">
        <option
          is="rep-options"
          v-for="rep in reps"
          v-bind:key="rep.id"
          v-bind:repgroup="rep">
        </option>
      </datalist>
      <div class="actions">
        <button type="submit">Submit Factory</button>
        <i @click="resetForm" class="material-icons">refresh</i>
      </div>
    </form>
    <div class="list__wrapper">
      <factory-entry
        class="header__line"
        v-bind:factory="{business_name: 'Business Name', website: 'Website', phone: 'Phone'}">
      </factory-entry>
      <factory-entry
        v-for="factory in factories"
        v-bind:key="factory.id"
        v-bind:factory="factory">
      </factory-entry>
    </div>
  </div>
</template>

<script>
import {store} from '@/store'
import RepOptions from '@/components/factories/RepOptions'
import FactoryEntry from '@/components/factories/FactoryEntry'

export default {
  name: 'FactoryManager',
  data: function() {
    return {}
  },
  computed: {
    factories: function(){
      return store.state.factories
    },
    reps: function(){
      return store.state.repgroups
    },
    business_name: {
      get(){ return store.state.newfactory.business_name },
      set(val){ store.commit('set_factory_business_name', val) }
    },
    phone: {
      get(){ return store.state.newfactory.phone },
      set(val){ store.commit('set_factory_phone', val) }
    },
    website: {
      get(){ return store.state.newfactory.website },
      set(val){ store.commit('set_factory_website', val) }
    },
    ak: {
      get(){ return store.state.newfactory.repgroups.ak },
      set(val) { store.commit('set_factory_rep_ak', val) }
    },
    can: {
      get(){ return store.state.newfactory.repgroups.can },
      set(val) { store.commit('set_factory_rep_can', val) }
    },
    co: {
      get(){ return store.state.newfactory.repgroups.co },
      set(val) { store.commit('set_factory_rep_co', val) }
    },
    hi: {
      get(){ return store.state.newfactory.repgroups.hi },
      set(val) { store.commit('set_factory_rep_hi', val) }
    },
    id: {
      get(){ return store.state.newfactory.repgroups.id },
      set(val) { store.commit('set_factory_rep_id', val) }
    },
    mt: {
      get(){ return store.state.newfactory.repgroups.mt },
      set(val) { store.commit('set_factory_rep_mt', val) }
    },
    or: {
      get(){ return store.state.newfactory.repgroups.or },
      set(val) { store.commit('set_factory_rep_or', val) }
    },
    tx: {
      get(){ return store.state.newfactory.repgroups.tx },
      set(val) { store.commit('set_factory_rep_tx', val) }
    },
    wa: {
      get(){ return store.state.newfactory.repgroups.wa },
      set(val) { store.commit('set_factory_rep_wa', val) }
    },
    wy: {
      get(){ return store.state.newfactory.repgroups.wy },
      set(val) { store.commit('set_factory_rep_wy', val) }
    }
  },
  methods: {
    submitFactory: function(){
      store.dispatch('createFactory')
    },
    resetForm: function(){
      store.commit('resetfactoryform')
    }
  },
  components: {
    RepOptions,
    FactoryEntry
  }
}
</script>

<style scoped lang="less">

.page__wrapper {
  display: block;
  width: 100%;
  margin-top: 60px;
  padding: 24px;
  box-sizing: border-box;
  position: relative;
}
.repgroup__form {
  display: block;
  width: 300px;
  background: #f4f4f4;
  padding: 24px 24px 60px 24px;
  box-sizing: border-box;
  position: fixed;
  top: 60px;
  left: 0px;
  bottom: 0px;
  overflow-y: auto;
  .actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 24px;
    button {
      padding: 12px 24px;
      color: white;
      background-color: #1882e6;
      border-radius: 3px;
      cursor: pointer;
      font-weight: bold;
      font-size: 0.9em;
    }
    i {
      padding: 12px;
      cursor: pointer;
    }
  }
  .form__name {
    font-weight: bold;
    display: block;
    font-size: 1.15em;
    background-color: inherit;
    position: sticky;
    top: 0px;
    padding: 12px 0px;
    margin-bottom: 12px;
    border-bottom: solid 1px lightgray;
  }
  label {
    font-size: 0.8em;
    color: #979797;
    font-weight: 100;
    text-transform: capitalize;
  }
  input {
    display: block;
    width: 100%;
    padding: 6px 0px;
    box-sizing: border-box;
    margin-bottom: 6px;
    background: transparent;
    border: none;
    border-bottom: dashed 1px lightgray;
    font-size: 0.9em;
    &:focus {
      outline: none;
      border-bottom: solid 1px;
    }
  }
}
.list__wrapper {
  display: block;
  padding-left: 300px;
  box-sizing: border-box;
}
.header__line {
  font-weight: bold;
  position: sticky;
  top: 60px;
  background-color: white;
  .actions {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/factories/FactoryManager.vue